import Vue from 'vue';
import VCalendar from 'v-calendar';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import Vuetify from 'vuetify'

import DaySpanVuetify from 'dayspan-vuetify'
import Meta from 'vue-meta'

import alert from './elements/Alert.vue';
import loader from './elements/Loader.vue';
import navigation from './components/Navigation.vue';

import routes from './routes.js';

import { mixin as clickaway } from 'vue-clickaway';

import { eventBus } from './eventBus.js';

import Vuecidity from 'vuecidity'
Vue.use(Vuecidity)

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

import BbrcAdvancedSearch from './components/BbrcAdvancedSearch.vue'
Vue.component('bbrc-advanced-search', BbrcAdvancedSearch)

Vue.use(VCalendar, {
    datePickerTintColor: '#5e8dff',
    firstDayOfWeek: 2,
    formats: {
        data: ['YYYY-MM-DD', 'L', 'YYYY/MM/DD'],
        dayPopover: 'YYYY-MM-DD',
        input: ['DD.MM.YYYY', 'L', 'YYYY/MM/DD'],
        navMonths: 'MMM',
        title: 'MMM YYYY',
        weekdays: 'WW'
    }
});
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Meta);
Vue.use(Vuetify);
Vue.use(DaySpanVuetify, {
    data: {
        defaults: {
            dsScheduleActions: {
                allowInclude: false,
                allowMove: false,
                allowSetStart: false,
                allowSetEnd: false
            }
        },
        supports: {
            title: true,
            description: true,
            color: true,
            location: true,
            calendar: false,
            busy: false,
            icon: true,
            guests: false
        }
    },
    methods: {
        getDefaultEventColor: function()  {
            return '#5e8dff';
        }
    }
});



Vue.http.interceptors.push(function(request, next) {
    if (store.state.user && !request.url.includes('googleapis.com')) {
        const token = store.state.user.token ? store.state.user.token : '';
        request.headers.set('Authorization', 'Bearer ' + token);
    }
    next();
});



const router = new VueRouter({
    mode: 'history',
    routes: routes
});

router.beforeEach(function (to, from, next) {
    const authorize = to.meta.authorize || null;
    const user = store.state.user;

    if (authorize && !user.is_admin) {
        // role not authorised so redirect to home page
        return next({ path: '/' });
    }

    if (user && to.name == 'home') {
        return next({ path: '/startdesks' });
    }
    
    // check if AddThis script should be show
    if (to.name == 'startdesks.view') {
        document.querySelectorAll('.addthis-smartlayers').forEach(function (addthis) {
            addthis.style.display = 'block';
            addthis.style.opacity = '1';
        });
    } else {
        document.querySelectorAll('.addthis-smartlayers').forEach(function (addthis) {
            addthis.style.display = 'none';
            addthis.style.opacity = '0';
        });
    }

    // set active startdesk and update URL
    const slug = to.params.startdesk;
    const myStartdesks = store.state.myStartdesks;

    if (myStartdesks) {
        const startdesk = store.state.myStartdesks.find(function (startdesk) {
            return startdesk.slug == slug;
        });

        if (startdesk) {
            store.commit('setActiveStartdesk', startdesk);
            app.setUserActiveStartdesk(startdesk);

        } else if (store.state.viewStartdesk && store.state.viewStartdesk.slug == slug) {
            store.commit('setActiveStartdesk', store.state.viewStartdesk);
        }
    }

    store.commit('setCurrentUrl', to.fullPath);

    next();

});





const store = new Vuex.Store({
    state: {
        activeStartdesk: null,
        currentUrl: window.location.href,
        isNavExpanded: false,
        isPluginInstalled: null,
        myStartdesks: null,
        navActiveTab: 'menu',
        user: JSON.parse(localStorage.getItem('user')),
        viewStartdesk: null
    },
    mutations: {
        loginUser: function (state, user) {
            state.user = user;
        },
        logoutUser: function (state) {
            state.user = null;
        },
        setActiveStartdesk: function (state, startdesk) {
            state.activeStartdesk = startdesk;
        },
        setCurrentUrl: function (state, url) {
            state.currentUrl = url;
        },
        setStartdesks: function (state, startdesks) {
            state.myStartdesks = startdesks;
        },
        setViewStartdesk: function (state, startdesks) {
            state.viewStartdesk = startdesks;
        },
        switchNavTab: function (state, tab) {
            state.navActiveTab = tab;
        },
        toggleNav: function (state) {
            state.isNavExpanded = !state.isNavExpanded;

            if (!state.isNavExpanded) {
                state.navActiveTab = 'menu';
            } else {
                state.navActiveTab = 'startdesks';
            }
        }
    }
});



Vue.mixin({
    computed: {
        activeBackgroundProperty: function () {
            let property = '';

            if (this.activeStartdesk) {
                if (this.activeStartdesk.background_color) {
                    property += 'background-color: ' + this.activeStartdesk.background_color + ';'
                }
                if (this.activeStartdesk.background_image) {
                    property += 'background-image: url(/media/wallpapers/' + this.activeStartdesk.background_image + ');'
                }
            }

            return property;
        },
        activeStartdesk: function () {
            return store.state.activeStartdesk;
        },
        isNavExpanded: function () {
            return store.state.isNavExpanded;
        },
        myStartdesks: function () {
            return store.state.myStartdesks;
        },
        navActiveTab: function () {
            return store.state.navActiveTab;
        },
        user: function () {
            return store.state.user;
        },
        isPluginInstalled: function () {
            if (store.state.isPluginInstalled === null) {
                try {
                    store.state.isPluginInstalled = true;
                    var browser = (window.msBrowser || window.browser || window.chrome);
                    browser.runtime.sendMessage('dfkpmfkmoholiefoakefhldjjbkpgged', { message: 'bbrc_ayt' },
                        function (reply) {
                            console.log(reply);
                            if (reply) {
                                if (reply.version) {
                                    console.log(reply.version);
                                    store.state.isPluginInstalled = true;
                                    //if (reply.version >= requiredVersion) {
                                    //    hasExtension = true;
                                    //}
                                } else {
                                    store.state.isPluginInstalled = false;
                                }
                            }
                            else {
                                store.state.isPluginInstalled = false;
                            }
                        });
                } catch (ex) {
                    store.state.isPluginInstalled = false;
                }
            }
            return store.state.isPluginInstalled;
        }
    },
    data: function () {
        return {
            apiUrl: '/api/v1',
            appUrl: window.location.protocol + "//" + window.location.host,
            langStrings: require('../../lang/en.json')
        }
    },
    methods: {
        __: function (key) {
            let string = this.langStrings[key] ? this.langStrings : key;

            if (arguments.length > 1) {
                if (string.match(/(\:.*?)(?:\s|$)/g).length == arguments.length - 1) {
                    for (let i = 1; i < arguments.length; i++) {
                        const match = string.match(/(\:.*?)(?:\s|$)/);
                        string = string.replace(match[1], arguments[i]);
                    }
                } else {
                    console.error('__(): number of placeholders doesn\'t match number of parameters.');
                }
            }

            return string;
        },
        changeStartdesk: function (startdesk) {
            store.commit('setActiveStartdesk', startdesk);
            this.setUserActiveStartdesk(startdesk);
        },
        getStartdesk: function (slug) {
            this.$http.get(this.apiUrl + '/startdesk/' + slug).then(function (response) {

                const startdesk = response.body.original;

                if (!document.cookie.includes('bbrchide')) {
                    if (startdesk.is_private && (!this.user || (this.user && startdesk.user.id != this.user.id && !this.user.is_admin))) {
                        this.$router.push({name: 'home'});
                        return;
                    }
                }

                let activeStartdesk = null;
                if (Object.keys(startdesk).length > 0) {
                    activeStartdesk = startdesk;
                } else if (this.myStartdesks.length > 0) {

                    let startdesks = this.myStartdesks;

                    const activeIndex = startdesks.findIndex(function (startdesk) {
                        return startdesk.slug == this.$route.params.startdesk;
                    }.bind(this));

                    activeStartdesk = startdesks[activeIndex != -1 ? activeIndex : 0];
                }

                store.commit('setActiveStartdesk', activeStartdesk);
                this.setUserActiveStartdesk(activeStartdesk);

                if ((this.user && this.$route.name == 'home') || this.$route.name == 'startdesks.view') {
                    this.$router.push({
                        name: 'startdesks.view',
                        params: {startdesk: activeStartdesk.slug, u: activeStartdesk.is_user_startdesk}
                    });
                }


                eventBus.$emit('hide-loader');
            }, function (response) {
                eventBus.$emit(
                    'show-alert',
                    'error',
                    this.__('There was an error retrieving data from the server.')
                );

                eventBus.$emit('hide-loader');
            });
        },
        getStartdesks: function () {
            store.commit('setStartdesks', null);
            store.commit('setActiveStartdesk', null);

            eventBus.$emit('show-loader');

            let filters = {};

            if (this.user) {
                filters.user = this.user.id;
            } else {
                filters.is_default = 1;
            }

            this.$http.get(this.apiUrl + '/startdesks', {
                params: {
                    filters: filters,
                    page: 1,
                    perPage: 0,
                    sortBy: 'order',
                    sortOrder: 'desc'
                }
            }).then(function (response) {
                const startdesks = response.body.original.data;

                this.updateStartdesks(startdesks);

                if (startdesks.length > 0) {
                    const activeIndex = startdesks.findIndex(function (startdesk) {
                        return startdesk.slug == this.$route.params.startdesk;
                    }.bind(this));
                    let activeStartdesk = null;
                    if (activeIndex == -1 && this.$route.params.startdesk) {
                        this.getStartdesk(this.$route.params.startdesk);
                    } else if (activeIndex != -1 && this.$route.params.startdesk) {
                        this.getStartdesk(startdesks[activeIndex].slug);
                    } else {

                        let activeStartdesks = startdesks.filter(function (startdesk) {
                            return startdesk.is_visible_to_user;
                        }.bind(this));

                        if (activeStartdesks.length > 0) {

                            activeStartdesk = activeStartdesks.filter(function (startdesk) {
                                return this.user ? startdesk.id == this.user.active_startdesk : false;
                            }.bind(this));

                            if (activeStartdesk.length == 0) {
                                activeStartdesk = activeStartdesks[activeIndex != -1 ? activeIndex : 0];
                            }
                            else {
                                activeStartdesk = activeStartdesk[0];
                            }

                            store.commit('setActiveStartdesk', activeStartdesk);
                            this.setUserActiveStartdesk(activeStartdesk);

                            if ((this.user && this.$route.name == 'home') || this.$route.name == 'startdesks.view') {
                                this.$router.push({
                                    name: 'startdesks.view',
                                    params: {startdesk: activeStartdesk.slug, u: activeStartdesk.is_user_startdesk}
                                });
                            }
                        }
                    }
                } else {
                    if (this.user) {
                        this.$router.push({
                            name: 'startdesks'
                        });
                    }
                }



                eventBus.$emit('hide-loader');
            }.bind(this), function (response) {
                eventBus.$emit(
                    'show-alert',
                    'error',
                    this.__('There was an error retrieving data from the server.')
                );

                eventBus.$emit('hide-loader');
            });
        },
        getUser: function () {
            if (!this.user) {
                if (JSON.parse(localStorage.getItem('user'))) {
                    localStorage.setItem('user', JSON.stringify(JSON.parse(localStorage.getItem('user'))));
                }
            }

            if (this.user) {
                this.$http.get(this.apiUrl + '/users/get-logged-user/' + this.user.id).then(function (response) {
                    let user = response.body;

                    if (Object.keys(user).length) {
                        this.user.is_admin = user.is_admin;
                        this.user.is_super_admin = user.is_admin;
                        this.user.role = user.role;
                        this.user.role_id = user.role_id;
                        this.updateUser(this.user);
                    } else {
                        this.logoutUser();
                    }
                }.bind(this));
            }
        },
        loginUser: function (user) {
            store.commit('loginUser', user);

            localStorage.setItem('user', JSON.stringify(user));

            this.$router.push(this.$route.query.redirect || '/');

            this.getStartdesks();
            this.setLastLogin();
        },
        logoutUser: function () {
            store.commit('logoutUser');

            localStorage.removeItem('user');

            this.$router.push('/');

            this.getStartdesks();
        },
        setLastLogin: function () {
            if (this.user) {
                this.$http.post(this.apiUrl + '/login/last/' + this.user.id);
            }
        },
        setUserActiveStartdesk: function (startdesk) {
            if (this.user) {
                this.$http.post(this.apiUrl + '/users/active-startdesk/' + this.user.id, {
                    active_startdesk: startdesk.id
                }).then(function() {
                    this.user.active_startdesk = startdesk.id;
                    this.updateUser(this.user);
                }.bind(this));
            }
        },
        switchNavTab: function (tab) {
            store.commit('switchNavTab', tab);
        },
        toggleNav: function () {
            store.commit('toggleNav');
        },
        updateStartdesks: function (startdesks) {
            store.commit('setStartdesks', startdesks);
        },
        updateUser: function (user) {
            user.token = this.user.token;
            store.commit('loginUser', user);

            localStorage.setItem('user', JSON.stringify(user));
        },
        viewStartdesk: function(startdesk) {
            store.commit('setViewStartdesk', startdesk);
        }
    }
});



const app = new Vue({
    el: '#app',
    components: {
        alert,
        loader,
        navigation
    },
    computed: {
        currentUrl: function () {
            return this.appUrl + store.state.currentUrl
        }
    },
    data: {
        activeTheme:  'light',
        isAuthNavActive: false
    },
    metaInfo: function () {
        return {
            meta: [
                { property: 'og:url', content: this.currentUrl, vmid: 'og:url' }
            ]
        }
    },
    methods: {
        closeAuthNav: function () {
            this.isAuthNavActive = false;
        },
        init: function () {
            // check which theme to load
            if (window.localStorage && localStorage.getItem('starterio-theme') != 'null') {
                this.setTheme(localStorage.getItem('starterio-theme'));
            }

            // check if AddThis script should be show
            window.onload = function () {
                if (/*this.$route.name == 'home' || */this.$route.name == 'startdesks.view') {
                    document.querySelectorAll('.addthis-smartlayers').forEach(function (addthis) {
                        addthis.style.display = 'block';
                        addthis.style.opacity = '1';
                    });
                } else {
                    document.querySelectorAll('.addthis-smartlayers').forEach(function (addthis) {
                        addthis.style.display = 'none';
                        addthis.style.opacity = '0';
                    });

                }
                //$("head").append($("<link rel='stylesheet' href='/css/flags.css' />"));
            }.bind(this);

            this.getStartdesks();
            this.getUser();
            this.setLastLogin();
        },
        setTheme: function (theme) {
            if (this.activeTheme != theme) {
                this.activeTheme = theme;

                if (window.localStorage) {
                    localStorage.setItem('starterio-theme', theme);
                }

                const alternate = document.querySelector('.theme[rel="stylesheet alternate"]');
                const current = document.querySelector('.theme[rel="stylesheet"]');

                alternate.rel = 'stylesheet';
                alternate.disabled = false;
                current.rel = 'stylesheet alternate';
                current.disabled = true;
            }
        },
        toggleAuthNav: function () {
            this.isAuthNavActive = !this.isAuthNavActive;
        }
    },
    mixins: [
        clickaway
    ],
    mounted: function () {
        this.init();
    },
    router: router
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js